import { render } from "./Indeterminate.vue?vue&type=template&id=58a52cb4"
import script from "./Indeterminate.vue?vue&type=script&lang=ts"
export * from "./Indeterminate.vue?vue&type=script&lang=ts"
script.render = render

export default script